module.exports = __webpack_public_path__ + "img/ps-turismo.4780d353.jpg";